import { Mage } from '../../../../aer-types/types'

export const mages: Mage[] = []
